import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl } from "../../helpers/constants";
import { getCookie, signout } from "../../helpers/cookies";
import { regionsParser, productsParser } from './mastersParser';

const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = getCookie("magiclock_admin_token");
        if (token) {
            headers.set('Authorization', `BEARER ${token}`)
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await customFetchBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 403) {
        signout(() => { window.location.href = "/login"; });
    }

    return result;
};

const mastersApis = createApi({
    reducerPath: 'mastersApis',
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 0,
    tagTypes: ["Regions", "Products"],
    endpoints: build => ({
        // regions
        getRegionsList: build.query({
            query: (params) => ({
                url: "/masters/regions/list",
                method: "GET",
                params: params
            }),
            transformResponse: (response) => regionsParser(response),
            providesTags: ['Regions'],
            keepUnusedDataFor: 5,
        }),
        getRegionsDropdown: build.query({
            query: (params) => ({
                url: "/masters/regions/dropdown",
                method: "GET",
                params: params
            }),
            transformResponse: (response) => response.result,
            providesTags: ['RegionsDropdown'],
            keepUnusedDataFor: 5,
        }),
        addNewRegions: build.mutation({
            query: (payload) => ({
                url: "/masters/regions",
                method: "POST",
                body: payload
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Regions'],
        }),
        updateRegions: build.mutation({
            query: (payload) => ({
                url: "/masters/regions",
                method: "PUT",
                body: payload
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Regions'],
        }),
        deleteRegions: build.mutation({
            query: (params) => ({
                url: "/masters/regions",
                method: "DELETE",
                params: params
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Regions'],
        }),
        // products
        getProductsList: build.query({
            query: (params) => ({
                url: "/masters/products/list",
                method: "GET",
                params: params
            }),
            transformResponse: (response) => productsParser(response),
            providesTags: ['Products'],
            keepUnusedDataFor: 5,
        }),
        getProductsDropdown: build.query({
            query: (params) => ({
                url: "/masters/products/dropdown",
                method: "GET",
                params: params
            }),
            transformResponse: (response) => response.result,
            providesTags: ['ProductsDropdown'],
            keepUnusedDataFor: 5,
        }),
        addNewProducts: build.mutation({
            query: (payload) => ({
                url: "/masters/products",
                method: "POST",
                body: payload
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Products'],
        }),
        updateProducts: build.mutation({
            query: (payload) => ({
                url: "/masters/products",
                method: "PUT",
                body: payload
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Products'],
        }),
        deleteProducts: build.mutation({
            query: (params) => ({
                url: "/masters/products",
                method: "DELETE",
                params: params
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Products'],
        }),
    }),
});

export const {
    useGetRegionsListQuery, useAddNewRegionsMutation, useUpdateRegionsMutation, useDeleteRegionsMutation, useGetRegionsDropdownQuery,
    useGetProductsListQuery, useAddNewProductsMutation, useUpdateProductsMutation, useDeleteProductsMutation, useGetProductsDropdownQuery,
} = mastersApis;
export default mastersApis;